import TagInputSignUp from "./TagInputSignUp";

export default TagInputSignUp;
